<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter" :query-api="vendorQuery"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesStoolPoSdrResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" :query-api="vendorQuery"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <mini-button :disable="$_notChecked" :loading="downloadLoading"
                                                 @btnClick="$_downloadBomDrawing">
                                        <i class="fa-solid fa-file-zipper"></i>
                                        技术文件下载
                                    </mini-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author Shi Wen Long
// Date 2022-02-10 14:49:06

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import emCommonApiMixin from "@/mixin/em/common/api";
import PageMaterialDownloadBomDrawingMixin from "@/views/sithMesII/pds/stuffs/page-material-download-bom-drawing-mixin";
import MiniButton from "@/components/common/buttons/MiniButton.vue";

export default {
    name: "sithMesStoolPoSdrListView",
    components: {MiniButton},
    mixins: [emCommonListMixin, emCustomVuexMixin, emCommonApiMixin, PageMaterialDownloadBomDrawingMixin],
    data() {
        return {
            vendorQuery: 'findByVendor',
        }
    },
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        headers() {
            let headers = {}
            let jwt = localStorage['em_sso_token']
            if (jwt != null) {
                headers['Authorization'] = jwt;
            }
            return headers;
        },
        entityBaseUrl() {
            return `${this.$_emApiMixin_entityBaseApi('sithMesStoolPoSdr')}/`
        },
        $_rowMaterialKey() {
            return 'materialCode';
        }
    },
    mounted() {
        // this.$refs["emListFilter"].$_emCustomVuexMixin_filterStore.idFilter = this.$route.query.id;
        this.$refs["emListFilter"].doQuery();
    }
};
</script>
